module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-top-stone-path.16056626.png";